import { Alert, Box, CloseButton, useColorModeValue } from "@chakra-ui/react";
import CDS from "design-system";
import CaminoAlertIcon from "components/Icon/CaminoAlertIcon";
import { useState } from "react";

const ALERT_DISMISSED_KEY = "newHireAlertDismissed";

function InfoAlert() {
  const [isVisible, setIsVisible] = useState(() => {
    const dismissed = localStorage.getItem(ALERT_DISMISSED_KEY);
    return dismissed !== "true";
  });
  const bg = useColorModeValue("alertBlue.200", "gray.700");

  const handleClose = () => {
    localStorage.setItem(ALERT_DISMISSED_KEY, "true");
    setIsVisible(false);
  };

  return (
    isVisible && (
      <Alert
        status="info"
        borderRadius="md"
        borderWidth="1px"
        borderColor="alertBlue.700"
        alignItems="center"
        bg={bg}
        width="fit-content"
        pr="10"
        py="2"
      >
        <Box as={CaminoAlertIcon} boxSize="20px" mr={2} />
        <Box flex="1" color="fg.emphasized" fontSize="sm">
          <CDS.Text12>
            All communications are{" "}
            <CDS.Text12 fontWeight="bold" as="span" color="fg.emphasized">
              currently pending
            </CDS.Text12>
            . Once you{" "}
            <CDS.Text12 fontWeight="bold" as="span" color="fg.emphasized">
              &ldquo;Kick Off Onboarding&ldquo;
            </CDS.Text12>
            , they become{" "}
            <CDS.Text12 fontWeight="bold" as="span" color="fg.emphasized">
              active
            </CDS.Text12>{" "}
            .
          </CDS.Text12>
        </Box>
        <CloseButton
          size="xs"
          position="absolute"
          right="2.5"
          sx={{ _hover: { bg: "transparent", color: "fg.emphasized" } }}
          onClick={handleClose}
        />
      </Alert>
    )
  );
}

export default InfoAlert;
